export interface CaseStatusLegendRow {
  key: string;
  label: string;
  description: string;
}

export interface CaseStatusHelpLegendViewProps {
  rows: CaseStatusLegendRow[];
}

/** Pure presenter: compact one-line-per-status rows for the Status column help popover. */
export function CaseStatusHelpLegendView({ rows }: CaseStatusHelpLegendViewProps) {
  return (
    <ul className="m-0 list-none divide-y divide-border-subtle p-0">
      {rows.map((row) => (
        <li key={row.key} className="py-1.5 text-xs leading-tight first:pt-0 last:pb-0">
          <span className="font-semibold text-foreground">{row.label}</span>
          <span className="text-text-faint" aria-hidden>
            {" "}
            —{" "}
          </span>
          <span className="text-muted-foreground">{row.description}</span>
        </li>
      ))}
    </ul>
  );
}
